import React from 'react';
import {Link} from 'react-router';
import ThemableComponent from "./theme/ThemableComponent";
import { Plural, useLingui } from '@lingui/react/macro';
import { getChildAgeRange } from '../utils/cartUtils';

function PriceInfoBox(props) {

    const {t} = useLingui();

    const getButton = () => {
        const classes = "action-button action-button-enabled block w-full ";
        if(props.buttonIsLink) {
            return (
                <Link className={classes} to={props.linkTo}>
                    {props.buttonText}
                </Link>
            );
        } else {
            return (
                <button className={classes} onClick={props._onClick}>
                    {props.buttonText}
                </button>
            );
        }
    };

    const getLimitedAvailabilityText = (currentAvailability, isWaitlist) => {
        if (currentAvailability > 20 || currentAvailability < 1) {
          return "";
        }
      
        if (currentAvailability > 9) {
          return isWaitlist ? t({ id: "limited_waitlist_spaces_available" }) : t({ id: "limited_spaces_available"});
        }

        return isWaitlist ? (
            <Plural id={"x_waitlist_spaces_remaining"} value={currentAvailability} one={"# Waitlist Space Remaining"} other={"# Waitlist Spaces Remaining"} />
        ) : (
            <Plural id={"x_spaces_remaining"} value={currentAvailability} one={"# Space Remaining"} other={"# Spaces Remaining"} />
        )
      };
    const limitedPlaces = getLimitedAvailabilityText(props.currentAvailability, props.isWaitlist);

    const adultPrice = props.adultPrice ? props.adultPrice : "XX";
    let childPrice = props.childPrice;
    let hideCurrencySymbol = false;
    let ageRange = getChildAgeRange();

    if (!props.childPrice) {
        childPrice = props.childPrice === 0 ? t({id:"free"}) : "N/A";
        hideCurrencySymbol = true;
    }

    if(props.minimumAge && props.minimumAge > 2) {
        ageRange = `(${props.minimumAge}-12)`;
        if(props.minimumAge > 12) {
            childPrice = "N/A";
            ageRange = getChildAgeRange();
        }
    }

    return (
        <div className={props.classes}>
            {limitedPlaces && <div className="mb-2"><span className="text-red border-dotted border-b border-red">{limitedPlaces}</span></div>}
            <ThemableComponent
                componentName="ExcursionPrices"
                adultPrice={adultPrice}
                hideCurrencySymbol={hideCurrencySymbol}
                childPrice={childPrice}
                ageRange={ageRange}
                currencySymbol={props.currencySymbol}
            />
            <div className="mt-2">
                {getButton()}
            </div>
        </div>
    );
}

export default PriceInfoBox;